import { useMemo } from 'react'
import { useGetVoices } from '@forwardflow/queries/campaign.queries'
import { FALLBACK_VOICES, TVoiceOption } from '../steps/voice/voices'

/**
 * The voices a campaign can use: the curated onboarding list from the
 * voice service, else the static pair. The first one is the one we
 * recommend; it is pre-selected everywhere.
 */
export const useVoiceOptions = () => {
   const { data } = useGetVoices()
   const all: TVoiceOption[] = useMemo(
      () => (data?.length ? (data as TVoiceOption[]) : FALLBACK_VOICES),
      [data]
   )
   const find = (voiceId?: string | null) =>
      [...all, ...FALLBACK_VOICES].find((v) => v.voiceId === voiceId) || all[0]
   return { all, recommended: all[0], find }
}
